<template src="./RiskIndicatorChips.html"></template>

<script>
export default {
  name: "RiskIndicatorChips",
  props: {
    chips: { type: Array, default: () => [] },
    activeId: { type: String, default: null },
    catalogStatus: { type: String, default: "idle" },
  },
  methods: {
    onClick(chip) {
      if (!chip.available) return;
      this.$emit("select", chip.id);
    },
  },
};
</script>

<style lang="scss" src="./RiskIndicatorChips.scss"></style>
